import { Component } from '@angular/core';

@Component({
  selector: 'app-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.scss']
})
export class ZoomComponent {
  useCase = 'zoomWithImage';
  selectedUseCase = 'zoomWithImage';
  useCases: string[] = [
    'zoomWithImage',
    'zoomWithiFrame'
  ];
  ariaLabels = {
    zoomSlider: 'zoom',
    zoomResetButton: 'zoom Reset',
    zoomOutButton: 'zoom Out',
    zoomInButton: 'zoom In',
  }
}
